// extracted by mini-css-extract-plugin
export default {"line":"AfishaListItem_line__jO4gG","fio":"AfishaListItem_fio__1T4j+"};